module.exports = __webpack_public_path__ + "static/media/computerEquipment.ca1eff83.svg";